import { useRef, useState } from 'react';
import { GoabIcon } from '@abgov/react-components';
import { useGoogleMaps } from '../../common/GoogleMapsContext';
import './GoogleGoabInput.css';

const GoogleGoabInput = (props) => {
    const { provinceCodes, onPopulate, form, width, disabled, getResourceValue } = props;
    const { isLoaded } = useGoogleMaps();
    
    const propsRef = useRef();
    propsRef.current = { provinceCodes, onPopulate, form, getResourceValue };

    const [searchText, setSearchText] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    if (!isLoaded) return null;

    // const endpoint = process.env.REACT_APP_GOOGLE_TEXT_SEARCH_ENDPOINT;

    const handleSearch = async (e) => {
        if (e.key && e.key !== 'Enter') return;
        e.preventDefault();

        if (!searchText.trim() || !window.google) return;

        setIsSearching(true);

        try {

            /*
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Goog-Api-Key': googleMapsApiKey,
                    'X-Goog-FieldMask': 'places.id,places.location,places.viewport,places.addressComponents'
                },
                body: JSON.stringify({ 
                    textQuery: searchText,
                    maxResultCount: 1 
                })
            });
            */

            const geocoder = new window.google.maps.Geocoder();

            const { results } = await geocoder.geocode({ address: searchText });

            if (!results || !results[0]) {
                form.setFieldError("mapLat", "RESOURCES@form.addressNotFound.label");
                return;
            }

            const result = results[0];

            const getComp = (type, short = false) => {
                const comp = result.address_components.find(c => c.types.includes(type));
                return comp ? (short ? comp.short_name : comp.long_name) : "";
            };

            const lat = result.geometry.location.lat();
            const lng = result.geometry.location.lng();

            const viewport = {
                low: {
                    latitude: result.geometry.viewport.getSouthWest().lat(),
                    longitude: result.geometry.viewport.getSouthWest().lng(),
                },
                high: {
                    latitude: result.geometry.viewport.getNorthEast().lat(),
                    longitude: result.geometry.viewport.getNorthEast().lng(),
                },
            };

            const addressData = {
                lat,
                lng,
                viewport,

                googleId: result.place_id,

                streetAddressLine1: result.formatted_address,
                streetAddressLine2: "",

                locality: getComp("locality"),
                postalCode: getComp("postal_code"),

                provinceName: getComp("administrative_area_level_1"),
                province: `${getComp("administrative_area_level_1", true)}-${getComp("country", true)}`,
                countryIso2: getComp("country", true),
            };

            if (onPopulate) {
                onPopulate(addressData, form, getResourceValue);
            }
        } catch (error) {
            console.error("Geocoder error:", error);
            form.setFieldError("mapLat", "RESOURCES@form.addressNotFound.label");
        }
        finally{
            setIsSearching(false);
        }
    };

    return (
        <div className="google-input--container" style={width ? { '--width': width } : undefined}>
            <div className="google-input--input" style={{ cursor: 'pointer' }}>
                <GoabIcon type="search" />
                <input
                    id="GoogleTextId"
                    type="text"
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                    onKeyDown={handleSearch}
                    disabled={disabled || isSearching}
                />
            </div>
        </div>
    );
};

export default GoogleGoabInput;
